<template>
  <div class="box">
    <div class="box-header">
      <h3 class="box-title">Featured Image (ຮູບປົກຢູ່ສະໄລ້)</h3>
      <p>W:1280 x H:480</p>
    </div>
    <div class="control">
      <label class="file-placeholder" @click="uploadFileFeature()">
        <!-- If don't have image -->
        <i class="fa-thin fa-image" v-if="!featureFile"></i>
        <img :src="featureFile" alt="" />
      </label>
    </div>
    <input
      hidden="hidden"
      name="image"
      ref="fileinputFeature"
      type="file"
      @input="onSelectFileFeature"
    />
    <input hidden="hidden" name="image" v-model="featureImage" type="text" />
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["isFeatureImage"],
  data() {
    return {
      featureImage: "",
      featureFile: null,
    };
  },
  watch: {
    featureImage: {
      handler(value) {
        this.$emit("input", value);
      },
      immediate: true,
      deep: true,
    },
    isFeatureImage() {
      (this.featureImage = this.isFeatureImage),
        (this.featureFile = `${this.$urlImageShow}` + this.isFeatureImage);
    },
  },
  methods: {
    uploadFileFeature() {
      this.$refs.fileinputFeature.click();
    },
    async onSelectFileFeature() {
      const input = this.$refs.fileinputFeature;
      const files = input.files;

      const file = files[0];
      // console.log(size, "MB")

      const formData = new FormData();

      formData.append("file", file);
      // console.log(formData)
      if (file) {
        const filesize = file.size / 1024;
        // console.log(filesize, "KB")
        const size = 5 * 1024;
        if (filesize < size) {
          this.errorfileSize = file.name;
          axios.defaults.headers.common[
            "Authorization"
          ] = this.$store.getters.Token;
          const res = await axios.post(`${this.$urlImage}`, formData);
          this.featureFile = `${this.$urlImageShow}` + res.data.fileKey;
          if (res.data.message) {
            this.errorfileSize = "The file must be .JPG, .PNG. JPEG, .SVG";
            this.featureImage = null;
            this.featureFile = null;
          }
          if (res.data.fileKey) {
            this.errorfileSize = file.name;
            this.featureImage = res.data.fileKey;

            if (files && files[0]) {
              const reader = new FileReader();
              reader.onload = (e) => {
                this.featureFile = e.target.result;
              };
              reader.readAsDataURL(files[0]);
              this.$emit("input is-focused", files[0]);
            }
          }
        } else {
          this.errorfileSize = "The file Size is too much";
          this.featureFile = null;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input {
  display: none;
}

.file-placeholder {
  content: "";
  aspect-ratio: 16/6;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 1px solid var(--border-color);
  background-color: var(--light-grey-color);

  cursor: pointer;

  i {
    color: var(--grey-color) !important;
    font-size: 7rem;
  }

  img {
    aspect-ratio: 16/6;
    object-fit: cover;
  }
}
</style>
